import { Plugin, ButtonView } from 'ckeditor5';

export default class Print extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('print', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Print',
                tooltip: true,
                withText: false, // Display only the icon, no text
                icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 2.5C7.01563 2.5 6 3.51563 6 4.75V5.5H5.25C3.46354 5.5 2 6.96354 2 8.75V15.75C2 16.9844 3.01563 18 4.25 18H6V19.25C6 20.4844 7.01563 21.5 8.25 21.5H15.75C16.9844 21.5 18 20.4844 18 19.25V18H19.75C20.9844 18 22 16.9844 22 15.75V8.75C22 6.96354 20.5365 5.5 18.75 5.5H18V4.75C18 3.51563 16.9844 2.5 15.75 2.5H8.25ZM8.25 4H15.75C16.1719 4 16.5 4.32813 16.5 4.75V5.5H7.5V4.75C7.5 4.32813 7.82813 4 8.25 4ZM5.25 7H18.75C19.724 7 20.5 7.77604 20.5 8.75V15.75C20.5 16.1719 20.1719 16.5 19.75 16.5H18V14.75C18 13.5156 16.9844 12.5 15.75 12.5H8.25C7.01563 12.5 6 13.5156 6 14.75V16.5H4.25C3.82813 16.5 3.5 16.1719 3.5 15.75V8.75C3.5 7.77604 4.27604 7 5.25 7ZM8.25 14H15.75C16.1719 14 16.5 14.3281 16.5 14.75V19.25C16.5 19.6719 16.1719 20 15.75 20H8.25C7.82813 20 7.5 19.6719 7.5 19.25V14.75C7.5 14.3281 7.82813 14 8.25 14Z" fill="black"/>
</svg>
`
            });

            // Define what happens when the button is clicked.
            view.on('execute', () => {
                // Get the editor data
                const data = editor.getData();

                // Create an iframe to hold the printable content
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                document.body.appendChild(iframe);

                // Write the editor's content into the iframe
                const doc = iframe.contentWindow.document;
                doc.open();
                doc.write(`
                    <html>
                        <head>
                            <title>Print Preview</title>
                            <style>
                                /* Add any specific print styles here */
                                body { font-family: Arial, sans-serif; margin: 20px; }
                                /* Example print-specific styles */
                            </style>
                        </head>
                        <body>${data}</body>
                    </html>
                `);
                doc.close();

                // Wait for the iframe content to load, then trigger the print
                iframe.contentWindow.focus();
                iframe.contentWindow.print();

                // Remove the iframe after printing
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 1000); // Give a slight delay before removing the iframe
            });

            return view;
        });
    }
}
